import {
  DELETE_MALWARE_DETECTION_ASYNC,
  GET_MALWARE_DETECTIONS_ASYNC,
  RESET_MALWARE_DETECTION_ERROR,
  UPDATE_MALWARE_DETECTION_ASYNC,
} from './constants'

const getMalwareDetections = () => ({
  type: GET_MALWARE_DETECTIONS_ASYNC.INITIATE,
})
const getMalwareDetectionsCancel = () => ({
  type: GET_MALWARE_DETECTIONS_ASYNC.CANCEL,
})
export const getMalwareDetectionsSuccess = ({ name, data }) => ({
  type: GET_MALWARE_DETECTIONS_ASYNC.SUCCESS,
  payload: { name, data },
})
export const getMalwareDetectionsError = (error) => ({
  type: GET_MALWARE_DETECTIONS_ASYNC.ERROR,
  error,
})

const updateMalwareDetection = ({ name, data }) => ({
  type: UPDATE_MALWARE_DETECTION_ASYNC.INITIATE,
  payload: { name, data },
})
const updateMalwareDetectionCancel = () => ({
  type: UPDATE_MALWARE_DETECTION_ASYNC.CANCEL,
})
export const updateMalwareDetectionSuccess = (data) => ({
  type: UPDATE_MALWARE_DETECTION_ASYNC.SUCCESS,
  payload: { data },
})
export const updateMalwareDetectionError = (error) => ({
  type: UPDATE_MALWARE_DETECTION_ASYNC.ERROR,
  error,
})

const deleteMalwareDetection = ({ name }) => ({
  type: DELETE_MALWARE_DETECTION_ASYNC.INITIATE,
  payload: { name },
})
const deleteMalwareDetectionCancel = () => ({
  type: DELETE_MALWARE_DETECTION_ASYNC.CANCEL,
})
export const deleteMalwareDetectionSuccess = (data) => ({
  type: DELETE_MALWARE_DETECTION_ASYNC.SUCCESS,
  payload: { data },
})
export const deleteMalwareDetectionError = (error) => ({
  type: DELETE_MALWARE_DETECTION_ASYNC.ERROR,
  error,
})

const resetDetectionItemError = () => ({ type: RESET_MALWARE_DETECTION_ERROR })

export default {
  // to props
  getMalwareDetections,
  getMalwareDetectionsCancel,
  updateMalwareDetection,
  updateMalwareDetectionCancel,
  deleteMalwareDetection,
  deleteMalwareDetectionCancel,
  resetDetectionItemError,
}
